import { render, staticRenderFns } from "./AddJob.vue?vue&type=template&id=9640af28&"
import script from "./AddJob.vue?vue&type=script&lang=js&"
export * from "./AddJob.vue?vue&type=script&lang=js&"
import style0 from "./AddJob.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports